import React from "react";
import { sizeFlag } from "../Helper";

type FlagBRProps = {
  size?: string | "small"
}

export const FlagBR: React.FC<FlagBRProps> = (props) => {
  const size = sizeFlag(props.size);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size.width}
      height={size.height}
      fill="none"
      viewBox="0 0 24 18"
    >
      <rect width="24" height="18" fill="#009B3A" />
      <polygon points="12,2 22,9 12,16 2,9" fill="#FFDF00" />
      <circle cx="12" cy="9" r="3.6" fill="#002776" />
      <path
        d="M8 8.8c1.6-1.2 4.3-1.5 8 .2"
        stroke="#FFF"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  )
}
